export default "__VITE_ASSET__CjzocfCL__"